module.exports = __webpack_public_path__ + "static/media/customer-gelato.0ac41f63.png";